/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.intervention.rti-forms'},
});

const RtiFormsItem = () => (
  <RouteLinkItem
    route="midas/settings/intervention/rti-forms"
    title={messages.title}
  />
);

export default RtiFormsItem;
